import * as S from './style';

function SecondGradient() {
    return (
        <S.SecondGradient xmlns="http://www.w3.org/2000/svg" width="911" height="824" viewBox="0 0 911 824" fill="none">
            <g filter="url(#filter0_f_308_497)">
                <path fillRule="evenodd" clipRule="evenodd" d="M817.451 -194C489.438 841.133 95.314 666.134 225.518 -57.1549H405.908C-61.9179 1082.67 801.398 1026.43 1229 -194H817.451Z" fill="url(#paint0_linear_308_497)" fillOpacity="0.63"/>
            </g>
            <defs>
                <filter id="filter0_f_308_497" x="0" y="-394" width="1429" height="1355" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
                    <feFlood floodOpacity="0" result="BackgroundImageFix"/>
                    <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>
                    <feGaussianBlur stdDeviation="100" result="effect1_foregroundBlur_308_497"/>
                </filter>
                <linearGradient id="paint0_linear_308_497" x1="200" y1="761" x2="200" y2="-194" gradientUnits="userSpaceOnUse">
                    <stop stopColor="#00AAFF"/>
                    <stop offset="0.5" stopColor="#1DD59F"/>
                    <stop offset="1" stopColor="#39FF3F"/>
                </linearGradient>
            </defs>
        </S.SecondGradient>
    )
}

export default SecondGradient;